import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Image from 'components/Basic/Image/Image';
import useTranslation from 'next-translate/useTranslation';
import { FooterSettingIconsType } from 'types/footerSetting';

type FooterIconsProps = {
    iconSection: FooterSettingIconsType;
};

const footerIconTextClassName = 'mr-5 text-tiny leading-4 tracking-wider text-grayDark';

const FooterIcons: FC<FooterIconsProps> = (props) => {
    const { t } = useTranslation();
    const iconsSection = props.iconSection;

    if (iconsSection.isVisible === false) {
        return null;
    }

    return (
        <div className="hidden vl:flex vl:flex-row vl:justify-between vl:pb-12">
            {iconsSection.payments.length > 0 && (
                <div className="flex items-center last:ml-20">
                    <div className={footerIconTextClassName}>{t('Payment options')}</div>
                    <div className="-ml-7 -mt-5 flex flex-wrap">
                        {iconsSection.payments.map((item, index) => (
                            <ExtendedNextLink
                                key={index}
                                className="relative ml-7 mt-5 h-7 w-[70px]"
                                href={item.url}
                                target="_blank"
                            >
                                <Image
                                    alt={item.url}
                                    className="h-7"
                                    height="28"
                                    src={item.mainImage?.url ?? null}
                                    width="70"
                                />
                            </ExtendedNextLink>
                        ))}
                    </div>
                </div>
            )}
            {iconsSection.transports.length > 0 && (
                <div className="flex items-center last:ml-20">
                    <div className={footerIconTextClassName}>{t('Delivery methods')}</div>
                    <div className="-ml-7 -mt-5 flex flex-wrap">
                        {iconsSection.transports.map((item, index) => (
                            <ExtendedNextLink
                                key={index}
                                className="relative ml-7 mt-5 h-7 w-[70px]"
                                href={item.url}
                                target="_blank"
                            >
                                <Image
                                    alt={item.url}
                                    className="h-7"
                                    height="28"
                                    src={item.mainImage?.url ?? null}
                                    width="70"
                                />
                            </ExtendedNextLink>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default FooterIcons;
